import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import RangeDatePicker from '@/components/RangeDatePicker/RangeDatePicker';

import useDownloadModal from './useDownloadModal';

export interface IDownloadModal {
  downloadReport: (createdAtStart: string, createdAtEnd: string) => void;
}

const DownloadModal = ({ downloadReport }: IDownloadModal) => {
  const hook = useDownloadModal({ downloadReport });

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="subtitle2" mb={2}>
        Elige las fechas en donde están las órdenes
      </Typography>
      <RangeDatePicker
        untilToday
        disablePortal={false}
        startLabel="Desde"
        endLabel="Hasta"
        onChange={(e, v) => {
          if (e === 'startDate') {
            hook.setDates((prev) => ({ ...prev, createdAtStart: v }));
          }
          if (e === 'endDate') {
            hook.setDates((prev) => ({ ...prev, createdAtEnd: v }));
          }
        }}
      />
      <Button
        sx={{ mt: '2rem', alignSelf: 'flex-end' }}
        onClick={hook.download}
        disabled={hook.isDisabled}
      >
        Descargar reporte
      </Button>
    </Box>
  );
};

export default DownloadModal;
